import { useMutation } from '@tanstack/react-query'
import { TPostApiRequestType } from '@/api/create-address/type'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'
import { APIInstance } from '@/utils/functions/instance'

export function useUpdateAddress({
  disableToast,
  ...rest
}: IApiBaseTypes<Partial<TPostApiRequestType>>) {
  return useMutation({
    mutationFn: async (data: Partial<TPostApiRequestType>) => {
      const response = await APIInstance<
        IResponseType<Partial<TPostApiRequestType>>
      >({
        url: 'mrf/address/',
        method: 'patch',
        data
      })
      return response.data
    },
    mutationKey: ['update-address'],
    retry: 0,
    ...rest
  })
}
